import React, { useContext, useEffect, useState } from "react";
import "../PPMContent/PPMContent.scss";
import "./CorporateGovernancePolicy.scss";
import "../SafeAggrement/SafeAggrement.scss";
import parser from "html-react-parser";
import { useNavigate } from "react-router-dom";
import { Context } from "../../contextApi/contextProvider";
import {
  
  cmsPublicContent,
} from "../../utils/cmscontent/cms";
import { MarkDocumentRead } from "../../utils/Api/api";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";

const TeamsOfUse = () => {
  const navigator = useNavigate();
  const loaction = useGeoLocation();
  const { userLoginData,} =
    useContext(Context);

  const [htmlStr, setHtmlStr] = useState<any>([]);
  const contents = [
    "1. INTERPRETATION AND DEFINITIONS ",
    "2. ACCEPTANCE OF TERMS & MODIFICATIONS",
    "3. PRIVACY ",
    "4. SUBSCRIPTION FEES & CANCELLATION ",
    "5. REGISTRATION & ACCOUNT MANAGEMENT ",
    "6. PAYMENTS",
    "7. ACCESS AND USE OF THE WEBSITE ",
    "8. USAGE RIGHTS AND RESPONSIBILITIES ",
    "9. AVAILABILITY OF SERVICE",
    "10.USAGE RESTRICTIONS",
    "11.ACCEPTABLE USE",
    "12.INTELLECTUAL PROPERTY RIGHTS",
    "13.RESPONSIBILITY FOR OTHERS",
    "14.LIMITATION OF LIABILITY",
    "15.TERMINATION",
    "16.SUPPORT & SECURITY",
    "17.WARRANTY",
    "18.INDEMNIFICATION",
    "19.GOVERNING LAW & JURISDICTION",
    "20.CHANGES TO TERMS",
    "21.SMS TERMS & CONDITIONS",
    "22.CONTACT US"
  ];

  const fetchCmsContent = async () => {
    const response = await cmsPublicContent({
      post_id: "7328",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  useEffect(() => {
        fetchCmsContent();
    document.title = "TICCA | Terms Of Use";
    window.scrollTo(0, 0);
  }, []);
    useEffect(() => { 
        readDoc();
  }, [userLoginData.status])

  const readDoc = async () => {
     if(userLoginData.status === 200){
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "7328",
      });
    } catch (error) {}
  };
}

  return (
    <>
       {htmlStr.length &&  <div className="watermaring-main-dev">
        <img
          src="https://public.ticca.com/images/svg/Watermark_Business_Summary.svg"
          alt="logo"
        />
        <p>
          Commercial in Confidence <br />
          Content under NDA.
          <br /> {userLoginData?.email}
        </p>
      </div> }
      {htmlStr.length <= 2 && (
        <div
          style={{ marginTop: "100px" }}
          className=" page-shimmer-container-co"
        >
          {Array.from({ length: 20 }).map((_, index) => (
            <div className="page-shimmer-co" key={index}></div>
          ))}
        </div>
      )}
      {htmlStr.length > 2 && (
        <div style={{ marginTop: "100px" }} className="shareholder-main-dev">
          <div className="safe-agreement-container">
            {/* Header */}
            <div className="header">
              <p className="cor-title">Terms of Use </p>
            </div>

            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>TABLE OF CONTENTS</h2>
              <ul>
                {contents.map((item, index) => (
                  <li key={index}>
                    <div className="line">
                      <span className="title">{item}</span>
                      <span className="dots"></span>
                      <span className="page-number">{3 + 1 + index}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="safe-agreement-container">
            {htmlStr.length > 1 &&
              htmlStr.map((elem: any, index: number) => (
                <div
                  key={`table-of-contentsr-${index}`}
                  className="safe-agreement-cms-container"
                >
                  {parser(elem)}
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TeamsOfUse;
